import {
  Col,
  Flex,
  Layout,
  Row,
  Typography,
  Avatar,
  Space, Spin
} from "antd";
import { Navigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";
import Logo from "../Logo";
import Background from "../Background";
import useCurrentUser from "../../hooks/useCurrentUser";
import { useAppSelector } from "../../store";
import { currentDoctor } from "../../store/slices/user";
import FeedbackForm from "./feedbackForm";
import { APP_PATH } from "../../constants/routes";
import { GET_FEEDBACK_PAGE } from "./feedback.qql";

const { Content } = Layout;
const { Title, Text } = Typography;

const Feedback = () => {
  const { t } = useTranslation();
  const { isDoctor } = useCurrentUser();
  const [searchParams] = useSearchParams();
  const doctor = useAppSelector(currentDoctor);

  const {
    data,
    loading: feedbackPageLoading
  } = useQuery<{
    feedbackPage: {
      id: number;
      appointment_id: number;
    }
  }>(GET_FEEDBACK_PAGE, {
    fetchPolicy: "no-cache",
    variables: {
      page_token: searchParams.get("key")
    },
  });

  if (isDoctor || !searchParams.get("key")) {
    return <Navigate to={APP_PATH}/>;
  }

  if (feedbackPageLoading) {
    return <Spin fullscreen spinning={feedbackPageLoading}/>;
  }

  return (
    <>
      <span style={{
        position: "absolute",
        top: "5vh",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 20
      }}
      >
        <Logo width={212} />
      </span>
      <Background step={5}/>
      <div style={{ position: "relative", zIndex: 10 }}>
        <Layout style={{ height: "100vh", background: "transparent" }}>
          <Content style={{
            maxWidth: "1200px", padding: "23vh 16px 0 ", width: "100%", margin: "0 auto"
          }}
          >
            <Row gutter={[32, 16]} style={{ height: "100%" }}>
              <Col
                span={24}
                lg={16}
              >
                <Flex
                  vertical
                  style={{ height: "56vh", width: "100%", position: "relative" }}
                >
                  <FeedbackForm feedbackId={data ? +data.feedbackPage.id : 0} />
                </Flex>
              </Col>
              <Col
                span={24}
                lg={8}
                style={{
                  paddingTop: 16,
                  paddingBottom: 16,
                }}
              >
                <Space direction="vertical" size="middle" style={{ width: "100%", marginBottom: 43 }}>
                  {!isDoctor && doctor?.photo
                    ? <Avatar size={121} src={<img src={doctor.photo} alt="avatar" />} />
                    : null}
                  <Title level={3} style={{ marginBottom: 0 }}>
                    {`${t("global.labels.doctorPrefix")} ${doctor?.name} ${doctor?.surname}`}
                  </Title>
                  <Text
                    type="secondary"
                    style={{ fontSize: 18, lineHeight: "1.2" }}
                  >
                    {doctor?.role === "oncologist"
                      ? t("global.labels.oncologistInfo")
                      : null}
                    {doctor?.role === "nutrizionist"
                      ? t("global.labels.nutritionistInfo")
                      : null}
                  </Text>
                </Space>
              </Col>
            </Row>
          </Content>
        </Layout>
      </div>
    </>
  );
};

export default Feedback;
